import React, { FunctionComponent } from 'react';
import { StatusActive, StatusScheduled, StatusSuccess } from '@liveramp/motif/icons';
import Tooltip from '@liveramp/motif/core/Tooltip';
import { CampaignStatus } from '../../filterOptions.enum';
import styles from './styles.module.scss';

interface Props {
  status: string;
}

const StatusIcon: FunctionComponent<Props> = ({ status }) => {
  switch (status) {
    case CampaignStatus.complete:
      return (
        <Tooltip title="Complete">
          <StatusSuccess data-test-id="complete-status-icon" className={styles.statusIcon} />
        </Tooltip>
      );
    case CampaignStatus.notStarted:
      return (
        <Tooltip title="Not Started">
          <StatusScheduled data-test-id="not-started-status-icon" className={styles.statusIcon} />
        </Tooltip>
      );
    case CampaignStatus.inFlight:
      return (
        <Tooltip title="In Flight">
          <StatusActive data-test-id="in-flight-status-icon" className={styles.statusIcon} />
        </Tooltip>
      );
    default:
      return null;
  }
};

export default StatusIcon;
